import { css } from 'aphrodite';
import * as React from 'react';
import HorizontalBarChart from 'src/components/charts/HorizontalBarChart';
import { TrendItem } from 'src/models/TrendItem';
import { TrendChart } from './charts/TrendChart';
import { ChartItem } from 'src/models/ChartItem';
import { Card, CardHeader, CardBody, ListGroup, ListGroupItem, Modal, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Popover, } from 'reactstrap';
import { PublicationListItem, PublicationAuthor } from 'src/models/PublicationListItem';
import { styles } from 'src/styles/AuthorPublications';
import { Author } from "src/models/CoAuthor";
import { PublicationData, sortItem } from 'src/mobx/FacultyPageStore';
import { AppStore, appStore } from '../mobx/AppStore';
import { observer, inject } from 'mobx-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImage, faDownload, faExpand, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import {SourceDetailDialog} from "src/components/dialogs/SourceDetailDialog";
import { PublicationDetailDialog } from './dialogs/PublicationDetailDialog';
import { RequestState } from 'src/models/RequestState';
import {AuthorDetailDialog} from "src/components/dialogs/AuthorDetailDialog";
import { SubjectAreaDetailDialog } from './dialogs/SubjectAreaDetailDialog';
import { PublicationSourceDialog } from './dialogs/PublicationSourceDialog';
import { PublicationAuthorDialog } from './dialogs/PublicationAuthorDialog';
import { PublicationSubjectAreaDialog } from './dialogs/PublicationSubjectAreaDialog';
import { Api } from 'src/core/api';
import axios from "axios";
import { JsonConvert } from 'json2typescript';
import { AuthorPublicationCombined, CoAuthorsAggregated, SubjectAreasAggregated } from 'src/models/AuthorPublicationsCombined';
import { ScaleLoader } from 'react-spinners';
import { URLBuilder } from 'src/core/URLBuilder';
import Graph from "react-graph-vis";
import fileDownload from 'js-file-download'
import {json2csv} from 'json-2-csv'
import domtoimage from 'dom-to-image';



interface IAuthorPublicationsProps {
    author_id: string;
    first_name: string;
    last_name: string;
}

enum ChartType {
    BAR,
    NETWORK
}

class AuthorPublicationState {
    public readonly selected_co_investigators_tab: number;
    public readonly selected_co_investigators_chart_type: ChartType = ChartType.NETWORK;
    public readonly isTrendBarSelected: boolean;
    public readonly isSourceDialogOpen: boolean;
    public readonly clickedSourceItemID: string;
    public readonly isPublicationDialogOpen: boolean;
    public readonly clickedPublicationItem: PublicationListItem;
    public readonly clickedSourceName: string;
    public readonly isAuthorDetailDialogOpen: boolean;
    public readonly clickedAuthorID: string;
    public readonly isSubjectAreaDialogOpen: boolean;
    public readonly clickedSubjectArea: string;
    public readonly isSourceExpanded: boolean;
    public readonly isAuthorExpanded: boolean;
    public readonly isSubjectAreaExpanded: boolean;

    constructor() {
        this.selected_co_investigators_tab = 0;
        this.isTrendBarSelected = false;
        this.isSourceDialogOpen = false;
        this.clickedSourceItemID = "";
        this.isPublicationDialogOpen = false;
        this.clickedPublicationItem = new PublicationListItem();
        this.clickedSourceName = "";
        this.isAuthorDetailDialogOpen = false;
        this.clickedAuthorID = "";
        this.isSubjectAreaDialogOpen = false;
        this.clickedSubjectArea = "";
        this.isSourceExpanded = false;
        this.isAuthorExpanded = false;
        this.isSubjectAreaExpanded = false;
    }
}

@inject('store')
@observer
export class AuthorPublications extends React.Component<IAuthorPublicationsProps, AuthorPublicationState> {

    constructor(props: IAuthorPublicationsProps) {
        super(props)
        this.state = new AuthorPublicationState();
    }

    public async componentDidMount() {
        if(this.state.isTrendBarSelected){
            this.fetchDataForYear(appStore.facultyPageStore.authorPageData.selectedYear)
        }else{
            this.fetchDataForRange(appStore.facultyPageStore.authorPageData.startYear, appStore.facultyPageStore.authorPageData.endYear); 
        }
           
    }

    private fetchDataForRange = (startYear: number, endYear: number) => {
        const author_id = this.props.author_id;
        appStore.facultyPageStore.authorPageData.setRequestState(RequestState.LOADING);
        const url = URLBuilder.author_publications_combined_view_for_range(author_id, startYear, endYear);
        axios.get(url).then((res)=> {
            appStore.facultyPageStore.authorPageData.setRequestState(RequestState.SUCCESS)
            if(res.status === 200){
                //decode the data
                const jsonConvert: JsonConvert = new JsonConvert();
                const data = jsonConvert.deserialize(res.data, AuthorPublicationCombined);
                appStore.facultyPageStore.authorPageData.fromResponse(data)
            }else{
                const error = res.statusText + ":" + res.data;
                appStore.facultyPageStore.authorPageData.setError(error);
            }    
        }).catch((err)=>{
            appStore.facultyPageStore.authorPageData.setError(err.toString());
        });
    }

    private fetchDataForYear = (year: number) => {
        const author_id = this.props.author_id;
        const authorPageData = appStore.facultyPageStore.authorPageData;
        authorPageData.setSelectedYear(year);
        authorPageData.setFilterRequestState(RequestState.LOADING);
        const url = URLBuilder.author_publications_combined_view(author_id, year);
        axios.get(url).then((res)=> {
            if(res.status === 200){
                //decode the data
                authorPageData.setFilterRequestState(RequestState.SUCCESS);
                const jsonConvert: JsonConvert = new JsonConvert();
                const data = jsonConvert.deserialize(res.data, AuthorPublicationCombined);
                authorPageData.fromResponse(data)
            }else{
                const error = res.statusText + ":" + res.data;
                authorPageData.setError(error);
            }    
        }).catch((err)=>{
            authorPageData.setError(err.toString());
        });
    }

    public render() {

        let content;
                
        if(appStore.facultyPageStore.authorPageData.requestState === RequestState.SUCCESS){
            content = (
                <React.Fragment>
                    {this.renderOverview()}
                    {this.renderCharts()}
                    {this.buildSourceDetailDialog()}
                    {this.buildPublicationDialog()}
                    {this.buildAuthorDetailDialog()}
                    {this.buildSubjectAreaDetailDialog()}
                    {this.buildSourceExpandedDialog()}
                    {this.buildAuthorExpandedDialog()}
                    {this.buildSubjectAreaExpandedDialog()}
                </React.Fragment>
            )
        }else if(appStore.facultyPageStore.authorPageData.requestState === RequestState.LOADING){
            content = (
                <React.Fragment>
                    <div className={css(styles.loader)} >
                        <ScaleLoader
                            height={50}
                            width={5}
                            color={'#808080ff'}
                            loading={true}
                            />
                    </div>
                </React.Fragment>
            )
        }else if(appStore.facultyPageStore.authorPageData.requestState === RequestState.ERROR){
            content = (<div>
                {appStore.facultyPageStore.authorPageData.error}
            </div>)
        }else{
            content = (<div></div>)
        }

        return (
            <div id="div_content" className={css(styles.content)} >
                 
                {content}

            </div>
        );
    }

    public renderOverview = () => {
        const publicationData = appStore.facultyPageStore.authorPageData.publicationData;
        const facultyName = this.props.first_name + " " + this.props.last_name  + "'s" ;
        const startYear = appStore.facultyPageStore.authorPageData.startYear;
        const endYear = appStore.facultyPageStore.authorPageData.endYear;
        const numberOfYears = endYear - startYear;
        return (
            <div id="overview" className={css(styles.overview)} >
                                
                <TrendChart data={publicationData.trend}
                    title={`${facultyName} Publication Count by Year from`}
                    onTrendBarClick={this.onTrendBarClick}
                    onTrendSelectionCleared={this.onTrendBarCleared}
                    labelName={"Year"}
                    valueLabel={"Publications"}
                    initStartYear={startYear}
                    initEndYear={endYear}
                    onRangeChanged={this.onTrendRangeChanged} 
                />

                <div id="info_container" className={css(styles.card)} >
                    <div id="h-score-section" className={css(styles.info_section)} >

                        <div id="label" className={css(styles.info_section_label)} >
                                {`h-index over ${numberOfYears} Years`} 
                            </div>

                        <div id="value" className={css(styles.info_section_value)} >
                            {publicationData.h_index}
                        </div>
                    </div>

                    <div id="seperator" className={css(styles.seperator)} />

                    <div id="documents-section" className={css(styles.info_section)} >

                        <div id="label" className={css(styles.info_section_label)} >
                            {`Publications over ${numberOfYears} Years`}
                        </div>

                        <div id="value" className={css(styles.info_section_value)} >
                            {publicationData.document_count}
                        </div>

                    </div>

                    <div id="seperator" className={css(styles.seperator)} />

                    <div id="citations-section" className={css(styles.info_section)} >

                        <div id="label" className={css(styles.info_section_label)} >
                            {`Citations over ${numberOfYears} Years`}
                        </div>

                        <div id="value" className={css(styles.info_section_value)} >
                            {publicationData.citations_count}
                        </div>
                    </div>
                </div>

            </div>
        );
    }

    public renderCharts = () => {

        const selectedYear = appStore.facultyPageStore.authorPageData.selectedYear;
        const startYear = appStore.facultyPageStore.authorPageData.getStartYear();
        const endYear = appStore.facultyPageStore.authorPageData.endYear;

        let publicationData; 
        
        if(this.state.isTrendBarSelected === false) {
            publicationData = appStore.facultyPageStore.authorPageData.publicationData;
        }else{
            publicationData = appStore.facultyPageStore.authorPageData.filteredPublicationData;
        }

        let journalLabel;
        let journalToolTip;
        let journalState;
        const facultyName = this.props.first_name + " " + this.props.last_name  + "'s" ;
        
        if(selectedYear === 0){
            journalLabel =  `${facultyName} Publications by Source from ${appStore.facultyPageStore.authorPageData.startYear} to ${endYear}`;
            journalToolTip = `${startYear}- ${endYear} (as reported on scopus.com)`;
            journalState = RequestState.SUCCESS;
        }else{
            journalLabel = `${facultyName} Publications by Source for Year: ${selectedYear}`
            journalToolTip = `For: ${selectedYear} (as reported on scopus.com)`;
            journalState = appStore.facultyPageStore.authorPageData.filterRequestState;
        }

        let subjectAreaLabel;
        let subjectAreaToolTip;
        let subjectAreaState;
        if(selectedYear === 0){
            subjectAreaLabel = `${facultyName} Publications by Subject Area from ${startYear} to ${endYear}`;
            subjectAreaToolTip = `For top 10 cited since from ${startYear}- ${endYear} (as reported on scopus.com)`;
            subjectAreaState = RequestState.SUCCESS;
        }else{
            subjectAreaLabel = `${facultyName}  Publications by Subject Area for Year: ${selectedYear}`
            subjectAreaToolTip = `For: ${selectedYear} (as reported on scopus.com)`;
            subjectAreaState = appStore.facultyPageStore.authorPageData.filterRequestState;
        }

        let coAuthorLabel;
        let coAuthorToolTip;
        let coAuthorState;
        if(selectedYear === 0){
            coAuthorLabel = `${facultyName} Co-Authors from ${startYear} to ${endYear}`;
            coAuthorToolTip = `For top 10 cited since from ${startYear}- ${endYear} (as reported on scopus.com)`;
            coAuthorState = RequestState.SUCCESS;
        }else{
            coAuthorLabel = `${facultyName} Co-Authors for Year: ${selectedYear}`
            coAuthorToolTip = `For: ${selectedYear} (as reported on scopus.com)`;
            coAuthorState = appStore.facultyPageStore.authorPageData.filterRequestState;
        }

        let coAuthorChart;
        if(this.state.selected_co_investigators_chart_type === ChartType.NETWORK){
            coAuthorChart = this.buildCoAuthorGraph(coAuthorLabel,coAuthorToolTip,coAuthorState,this.getCoAuthors(publicationData))
        }else{
            coAuthorChart = (
                <HorizontalBarChart id="co_investigators"
                    data={this.getCoAuthors(publicationData)}
                    title={coAuthorLabel}
                    tooltip={coAuthorToolTip}
                    customViews={this.buildCoInvestigatorsCustomView()}
                    yAxisWidth={100}
                    labelName={"Author"}
                    valueLabel={"Num of Pubs"}
                    state ={coAuthorState}
                    error = {appStore.facultyPageStore.authorPageData.error}
                    onItemClick={this.onAuthorItemClick}
                    onExpandClick={this.onAuthorExpandClick}
                />
            );
        }

        return (
            <div id="charts_container" className={css(styles.charts_container)} >
                <HorizontalBarChart id="journal"
                    data={publicationData.publications_by_journal.slice(0, 10)}
                    title={journalLabel}
                    tooltip={journalToolTip}
                    labelName={"Source"}
                    valueLabel={"Num of Pubs"}
                    onItemClick={this.onSourceItemClick}
                    state = {journalState}
                    error = {appStore.facultyPageStore.authorPageData.error}
                    onExpandClick={this.onSourceExpandClick}
                />

                <HorizontalBarChart id="subject_area"
                    data={publicationData.publications_by_subject_area.slice(0, 10)}
                    title={subjectAreaLabel}
                    tooltip={subjectAreaToolTip}
                    labelName={"Subject Area"}
                    valueLabel={"Num of Pubs"}
                    state = {subjectAreaState}
                    error = {appStore.facultyPageStore.authorPageData.error}
                    onItemClick={this.onSubjectAreaItemClick}
                    onExpandClick={this.onSubjectAreaExpandClick}
                />

                {coAuthorChart}

                {this.buildPublications(publicationData)}
                                                
            </div>
        )
    }

    private buildCoInvestigatorsCustomView = () => {
        return (
            <div className={css(styles.coInvestigatorsCustomViewContainer)} >
                {this.buildCoInvestigatorsChartTypeDropDown()}
                {this.buildCoInvestigatorsFilterDropDown()}
            </div>
        );
    }


    private onSourceExpandClick = () => {
        const newState = {...this.state, isSourceExpanded: true}
        this.setState(newState);
    }

    private buildSourceExpandedDialog = () => {
        return (
            <PublicationSourceDialog isOpen={this.state.isSourceExpanded} onClose={this.onSourceDialogClose} />
        );
    }

    private onSourceDialogClose = () => {
        const newState = {...this.state, isSourceExpanded: false};
        this.setState(newState);
    }

    private onAuthorExpandClick = () => {
        const newState = {...this.state, isAuthorExpanded: true}
        this.setState(newState);
    }

    private buildAuthorExpandedDialog = () => {
        return (
            <PublicationAuthorDialog isOpen={this.state.isAuthorExpanded} onClose={this.onAuthorExpandedDialogClose} />
        );
    }

    private onAuthorExpandedDialogClose = () => {
        const newState = {...this.state, isAuthorExpanded: false};
        this.setState(newState);
    }

    private onSubjectAreaExpandClick = () => {
        const newState = {...this.state, isSubjectAreaExpanded: true}
        this.setState(newState);
    }

    private buildSubjectAreaExpandedDialog = () => {
        return (
            <PublicationSubjectAreaDialog isOpen={this.state.isSubjectAreaExpanded} onClose={this.onSubjectAreaExpandedDialogClose} />
        );
    }

    private onSubjectAreaExpandedDialogClose = () => {
        const newState = {...this.state, isSubjectAreaExpanded: false};
        this.setState(newState);
    }
    
    private getCoAuthors = (publicationData: PublicationData) => {
        let items;
        if (this.state.selected_co_investigators_tab === 0) {
            items = publicationData.coauthors.slice(0, 10).sort(sortItem);
        } else if (this.state.selected_co_investigators_tab === 1) {
            items = publicationData.coauthors.filter(this.isTrue).slice(0, 10).sort(sortItem);
        } else {
            items = publicationData.coauthors.filter(this.isFalse).slice(0, 10).sort(sortItem);
        }
        return items;
    }

    private isTrue = (chartItem: ChartItem) => {
        const value: CoAuthorsAggregated = chartItem.payload;
        return value.UD_flag;
    }

    private isFalse = (chartItem: ChartItem) => {
        const value: string = chartItem.payload;
        return value.toString().toLowerCase() === "false";
    }

    private toggleModal = () => {
        this.setState({ ...this.state, isSourceDialogOpen: !this.state.isSourceDialogOpen })
    }

    private onTrendRangeChanged = (startYear: number, endYear: number) => {
        appStore.facultyPageStore.authorPageData.setRange(startYear,endYear);
        this.fetchDataForRange(startYear,endYear); 
    }

    private onTrendBarClick = (entry: TrendItem, index: number) => {
        //this.setState({ ...this.state, isTrendBarSelected: true});
        appStore.facultyPageStore.authorPageData.setSelectedYear(entry.year);
        this.fetchDataForYear(entry.year);
    }

    private onTrendBarCleared = () => {
        //this.setState({ ...this.state, isTrendBarSelected: false});
        appStore.facultyPageStore.authorPageData.clearSelectedYear();
    }

    private buildCoInvestigatorsFilterDropDown = () => {
        return (
            <UncontrolledDropdown size="sm" className={css(styles.coauthorFilterTypeDrowdown)} >
                <DropdownToggle caret={true}>
                    {this.getCoInvestigatorDropDownLabel()}
                </DropdownToggle>
                <DropdownMenu >
                    <DropdownItem onClick={(event: any) => this.onCoAuthorTabSelected(0)}>ALL</DropdownItem>
                    <DropdownItem onClick={(event: any) => this.onCoAuthorTabSelected(1)}>UDEL</DropdownItem>
                    <DropdownItem onClick={(event: any) => this.onCoAuthorTabSelected(2)}>NON-UDEL</DropdownItem>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    }

    private onCoAuthorTabSelected = (value: number) => {
        this.setState({ ...this.state, selected_co_investigators_tab: value })
    }

    private getCoInvestigatorDropDownLabel = () => {
        if (this.state.selected_co_investigators_tab === 0) {
            return "ALL";
        } else if (this.state.selected_co_investigators_tab === 1) {
            return "UDEL";
        } else {
            return "NON-UDEL";
        }
    }

    private getPublications = (publicationData: PublicationData) => {
        return publicationData.publications_detail;
    }

    private buildPublications = (publicationData: PublicationData) => {
        
        let label;
        const selectedYear = appStore.facultyPageStore.authorPageData.selectedYear;
        const facultyName = this.props.first_name + " " + this.props.last_name  + "'s" ;
        let state;
        if(selectedYear === 0){
            label = `${facultyName} Publications`;
            state = appStore.facultyPageStore.authorPageData.requestState;
        }else{
            label = `${facultyName} Publications for Year: ${selectedYear}`;
            state = appStore.facultyPageStore.authorPageData.filterRequestState;
        }


        let body;
        if(state === RequestState.LOADING){
            body = (
                <div>
                    Loading
                </div>
            )
        }else{
            body = <ListGroup flush={true} className={css(styles.publicationList)} >
            {publicationData.publications_detail.map(this.buildPublicationItem)}
        </ListGroup>
        }

        return (
            <Card id="publications" className={css(styles.card, styles.publicationsCard)}>
                <CardHeader className={css(styles.publicationCardHeader)} >
                    <div>
                        {label}
                    </div>

                    <div onClick={this.onDownloadPublicationClick} title={"Download citations"} className={css(styles.icon)}  >
                            <FontAwesomeIcon icon={faDownload} />
                    </div>

                </CardHeader>
                <CardBody>
                    {body}
                </CardBody>
            </Card>
        );
    }

    private buildCoAuthorGraph = (label:string, tooltip: string, requestState: RequestState, data: ChartItem[]) => {
        
        const graph_nodes  = []
        const graph_edges = []

        // add the central author node 
        graph_nodes.push({ id: 0, label: this.props.first_name + " " + this.props.last_name})
        
        let largest_amount = 0;
        
        //add the other nodes
        for(let i = 0;i<data.length;i++){
            const item = data[i];
            graph_nodes.push({id: i+1, label: item.name })
            graph_edges.push({ from: i+1, to: 0, width: item.amount, label: item.amount})
            if(item.amount > largest_amount){
                largest_amount = item.amount;
            }
        }    

        const graph = {
            nodes: graph_nodes,
            edges: graph_edges,
        };
        
        const options = {
            layout: {
                hierarchical: false,
            },
            interaction: {
                hover: true,
                hoverConnectedEdges: true
            },
            edges: {
                arrows: {
                    to: false,
                },
                arrowStrikethrough: false,
                hoverWidth: (width : number)=> {
                    return width * 0.98;
                },
                selectionWidth: (width : number)=> {
                    return width * 0.98;
                },
            },
            autoResize: true,
            width: "100%",
            height: "300px",
            clickToUse: false
        };
        
          const events = {
            select: (event: any) => {
              const { nodes, edges } = event;
            }
          };

        return (
            <Card id="coauthor_network" className={css(styles.card)}>
                <CardHeader className={css(styles.coauthorNetworkCardHeader)} >
                    
                    <div className={css(styles.label_container)}>
                        <div className={css(styles.card_label)}>
                            {label}
                        </div>

                        <div id={"ic_help"} className={css(styles.icon)} >
                                <FontAwesomeIcon icon={faQuestionCircle} />
                        </div>

                    </div>

                    <div id="custom_views" className={css(styles.customViews)} >
                        {this.buildCoInvestigatorsCustomView()}
                    </div>
                    
                    <div id="icons" className={css(styles.coAuthorCharticons)} >
                        <div className={css(styles.icon)} title={"Save as image"} onClick={this.onCoAuthorDownloadImageClick} >
                            <FontAwesomeIcon icon={faFileImage} />
                        </div>

                        <div className={css(styles.icon)} title={"Download data"} onClick={this.onCoAuthorDownloadDataClick}>
                            <FontAwesomeIcon icon={faDownload} />
                        </div>

                        <div className={css(styles.icon)} title={"Expand chart"} >
                            <FontAwesomeIcon icon={faExpand} />
                        </div>
                 </div>  

                </CardHeader>
                <CardBody>
                    <div 
                     style={{
                        "width": "45vw",
                        "height": "300px",
                    }} >
                        <Graph
                                graph={graph}
                                options={options}
                                events={events}
                                autoResize={false}
                                getNetwork={ (network: any) => {
                                    //  if you want access to vis.js network api you can set the state in a parent component using this property
                                    network.focus(0, {scale: 0.80})
                                    //network.fit()
                                }}
                            />
                    </div>
                </CardBody>
            </Card>
        );
    }

    private onCoAuthorDownloadImageClick = (event: any) => {
        const element = document.getElementById("coauthor_network");
        if(element !== null){
            domtoimage.toBlob(element)
            .then((blob: any) => {
                fileDownload(blob, `coauthor_network.png`);
            });
        }
    }

    private onCoAuthorDownloadDataClick = (event: any) => {
        const selectedYear = appStore.facultyPageStore.authorPageData.selectedYear;
        let publicationData;
        if(selectedYear === 0) {
            publicationData = appStore.facultyPageStore.authorPageData.publicationData;
        }else if(appStore.facultyPageStore.authorPageData.requestState === RequestState.SUCCESS) {
            publicationData = appStore.facultyPageStore.authorPageData.filteredPublicationData;
        }else{
            publicationData = appStore.facultyPageStore.authorPageData.filteredPublicationData;
        }
        json2csv(this.getCoAuthors(publicationData),(err: any,csv: any) => {
            fileDownload(csv,"data.csv")
        })
    }

    private buildCoInvestigatorsChartTypeDropDown = () => {
        return (
            <UncontrolledDropdown size="sm" className={css(styles.coauthorChartTypeDrowdown)}>
                        <DropdownToggle caret={true}>
                            {this.getCoAuthorChartTypeDropDownLabel()}
                        </DropdownToggle>
                        <DropdownMenu >
                            <DropdownItem onClick={(event: any) => this.onCoInvestigatorChartSelected(ChartType.NETWORK)}>Network</DropdownItem>
                            <DropdownItem onClick={(event: any) => this.onCoInvestigatorChartSelected(ChartType.BAR)}>Bar</DropdownItem>
                        </DropdownMenu>
            </UncontrolledDropdown>
        );
    }

    private onCoInvestigatorChartSelected = (chartType: ChartType) => {
        this.setState({...this.state, selected_co_investigators_chart_type:chartType})
    }

    private getCoAuthorChartTypeDropDownLabel = () => {
        if (this.state.selected_co_investigators_chart_type === ChartType.NETWORK) {
            return "Network";
        } else if (this.state.selected_co_investigators_chart_type === ChartType.BAR) {
            return "Bar";
        } else {
            return "";
        }
    }

    private onDownloadPublicationClick = (event: any) => {
        const publicationData = appStore.facultyPageStore.authorPageData.publicationData.publications_detail;
        const bibtex = publicationData.map((pubItem: PublicationListItem)=>{return pubItem.bibtex});
        const bibtex_string = bibtex.filter((bibtex_str: string)=>{return bibtex_str.length > 0}).join(",\n");
        fileDownload(bibtex_string, "publications.csv");
    }

    private buildPublicationItem = (publication: PublicationListItem, index: number) => {
        return (
            <ListGroupItem key={index} >
                <div>
                    <h6>
                        <div className={css(styles.publicationTitle)} onClick={(event: any)=>{this.onPublicationItemClick(publication)}}>
                            {publication.title}
                        </div>
                    </h6>
                    <div style={{ fontSize: "12px" }}>
                        {this.buildCoauthors(publication.authors)}
                    </div>
                    <div style={{ fontSize: "10px" }} >
                        {publication.source_name}, {publication.pub_date}
                    </div>
                </div>
            </ListGroupItem>);
    }


    private onPublicationItemClick = (publication: PublicationListItem) => {
        const newState = {...this.state, isPublicationDialogOpen: true, clickedPublicationItem: publication};
        this.setState(newState);
    }

    private onPublicationDialogClose = () => {
        const newState = {...this.state, isPublicationDialogOpen: false};
        this.setState(newState);
    }

    private buildPublicationDialog = () => {
        return (<PublicationDetailDialog isOpen={this.state.isPublicationDialogOpen}
                                         onClose={this.onPublicationDialogClose}
                                         data={this.state.clickedPublicationItem}
                                         isMinimal={false}
                                         />)
    }

    
    
    private buildCoauthors(coauthors: PublicationAuthor[]): string {
        let data;
        if(coauthors.length > 10){
            data = coauthors.slice(0,10);
        }else{
            data = coauthors;
        }

        const combinedNames = data.map((author: PublicationAuthor)=>{
            return author.first_name + " " + author.last_name; 
        })

        const coauthor_str = combinedNames.join(", ")
        return coauthor_str;
    }

    private buildSourceDetailDialog = () => {
        return (
            <SourceDetailDialog isOpen={this.state.isSourceDialogOpen} onClose={()=>{
                const newState = {...this.state, isSourceDialogOpen: false}
                this.setState(newState)
            }} 
            id={this.state.clickedSourceItemID}
            name={this.state.clickedSourceName} />
        );
    }

    private onSourceItemClick = (chartItem: ChartItem) => {
        const name = JSON.parse(chartItem.name).name;
        const id = JSON.parse(chartItem.payload).source_id;
        const newState = {...this.state, isSourceDialogOpen: true, clickedSourceName: name, clickedSourceItemID: id}
        this.setState(newState)
    }

    private onAuthorItemClick = (chartItem: ChartItem) => {
        const coauthor: CoAuthorsAggregated = chartItem.payload;
        const newState = {...this.state, isAuthorDetailDialogOpen: true, clickedAuthorID: coauthor.author_id.toString()}
        this.setState(newState)
    }


    private buildAuthorDetailDialog = () => {
        return (
            <AuthorDetailDialog isOpen={this.state.isAuthorDetailDialogOpen} id={this.state.clickedAuthorID} onClose={this.onAuthorDetailDialogClose}/>
        );
    }
    
    private onAuthorDetailDialogClose = () => {
        const newState = {...this.state, isAuthorDetailDialogOpen: false}
        this.setState(newState)
    }

    private onSubjectAreaItemClick = (chartItem: ChartItem) => {
        const subject_area: SubjectAreasAggregated = chartItem.payload;
        console.log(subject_area)
        const newState = {...this.state, isSubjectAreaDialogOpen: true, clickedSubjectArea: subject_area.area_code}
        this.setState(newState)
    }

    private buildSubjectAreaDetailDialog = () => {
        return (
            <SubjectAreaDetailDialog isOpen={this.state.isSubjectAreaDialogOpen} id={this.state.clickedSubjectArea} onClose={this.onSubjectAreaDetailDialogClose}    />
        );
    }

    private onSubjectAreaDetailDialogClose = () => {
        const newState = {...this.state, isSubjectAreaDialogOpen: false}
        this.setState(newState)
    }

}




// WEBPACK FOOTER //
// ./src/components/AuthorPublications.tsx